import React from 'react';
import PropTypes from 'prop-types';
import { useQuery } from '@tanstack/react-query';

import Loader from 'components/Loader';
import './ManageUserDashboards.scss';
import { User } from 'models/user';
import { getUserDashboardsQuery } from 'routes/dashboards';
import { Link } from 'react-router-dom';

interface ManageUserDashboardsProps {
    user: User;
}

export default function ManageUserDashboards(props: ManageUserDashboardsProps) {
    const { data: userDashboards = [], isLoading } = useQuery(getUserDashboardsQuery(props.user.id));

    return (
        <div className="manage-user-dashboards" data-testid="manage-user-dashboards">
            <h2 className="manage-user-dashboards__heading">Dashboards</h2>

            {isLoading ? (
                <Loader />
            ) : userDashboards.length === 0 ? (
                <div className="manage-user-dashboards__no-dashboards">User has no dashboards attached</div>
            ) : (
                <>
                    <ul className="manage-user-dashboards__list">
                        {userDashboards.map((userDashboard) => (
                            <li className="manage-user-dashboards__dashboard" key={userDashboard.id}>
                                <Link to={`/admin/dashboards/${userDashboard.id}/edit`}>
                                    {userDashboard.name} ({userDashboard.id})
                                </Link>
                            </li>
                        ))}
                    </ul>
                </>
            )}
        </div>
    );
}

ManageUserDashboards.propTypes = {
    dashboard: PropTypes.object,
};
